import { Component, OnInit } from '@angular/core';
import { Input } from "../../../../../../components/forms/input/input";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModePassationMarcheReq, ModePassationMarcheSubRequest } from '../../../../../../data/http/requests/modepassationmarche.req';
import { AppService } from '../../../../../../core/app.service';
import { toSnakeCaseUpper, transformString } from '../../../../../../utils/helpers';
import { ModePassationMarcheService } from '../../../../../../services/modepassation.service';
import { ModePassationMarcheRes } from '../../../../../../data/http/responses/modepassationmarche.res';
import { LoaderComponent } from "../../../../../../components/ui/loader/loader.component";
import { debounceTime } from 'rxjs';
import { Router } from '@angular/router';
import { routeAlias } from '../../../../../../../routesalias';
import { TypeModePassationMarcheService } from '../../../../../../services/typepassation.service';
import { TypeModePassationRes } from '../../../../../../data/http/responses/typepassation.res';
import { SelectOption } from '../../../../../../data/schemas/selectoption.schema';
import { SelectComponent } from '../../../../../../components/forms/select/select.component';
import { UiButtonComponent } from '../../../../../../components/button/button.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-add',
  imports: [Input, ReactiveFormsModule, LoaderComponent, SelectComponent, UiButtonComponent, RouterLink],
  templateUrl: './add.component.html',
  styleUrl: './add.component.css'
})
export class AddModePassationmarchePageComponent implements OnInit {

  modePassationMarcheForm!: FormGroup;
  public modePassationMarches: ModePassationMarcheRes[] = []
  public isLoading: boolean = false;
  public totalDelais: number = 0;
  public typeModePassations: SelectOption[] = []
  public routeAlias = routeAlias;
  constructor(
    private fb: FormBuilder,
    private appService: AppService,
    private modePassationMarcheService: ModePassationMarcheService,
    private typeModePassationService: TypeModePassationMarcheService,
    private router: Router
  ) {
    this.modePassationMarcheForm = this.fb.group({
      typeModePassationMarche: ['', Validators.required],
      modePassationMarche: ['', Validators.required],
      mode: ['', Validators.required],
      delaiPublication: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      seuil: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      montage: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      lancement: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      ouverture: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      evaluation: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      negociationGreGre: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      organeControle: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      verificationDisponibiliteCredits: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      notificationResultats: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      delaiAttenteElaborationContrat: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      examenJuridiqueProjetContratCJC: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      signatureContratTitulaire: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      visaContratJuriste: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      visaContratDM: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      visaContratDFC: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      visaContratDCGIS: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      visaContratDGA: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      signatureContratDG: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      notificationContratTitulaireSC: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      delaiDelivranceOS: ['', [Validators.required, Validators.pattern('^\\d+$')]],
      applicationId: this.appService.getAppId(),
    });
  }

  ngOnInit(): void {
    this.loadModePassationMarche();
    this.loadTypeModePassation();
    // S'abonner aux changements de valeur du formulaire pour recalculer le total
    this.modePassationMarcheForm.valueChanges.pipe(
      debounceTime(300) // Optionnel: pour éviter des calculs trop fréquents lors de la saisie rapide
    ).subscribe(() => {
      this.calculateTotalDelais();
    });
    this.calculateTotalDelais();
  }

  saveModePassationMarche(): void {
    if (this.modePassationMarcheForm.valid) {
      this.isLoading = true
      //const mode = transformString(this.modePassationMarcheForm.value.modePassationMarche)
      // Liste des champs à exclure du tableau details
      const excludedFields = ['modePassationMarche', 'applicationId', 'mode', 'typeModePassationMarche'];

      // Création du tableau details
      const details: ModePassationMarcheSubRequest[] = [];

      // Parcourir tous les champs du formulaire
      Object.keys(this.modePassationMarcheForm.value).forEach(key => {
        // Exclure les champs spécifiés
        if (!excludedFields.includes(key)) {
          details.push({
            code: toSnakeCaseUpper(key),
            valeur: parseInt(this.modePassationMarcheForm.value[key], 10)
          });
        }
      });
      let requestBody: ModePassationMarcheReq = {
        applicationId: this.modePassationMarcheForm.value.applicationId,
        code: this.modePassationMarcheForm.value.mode,
        libelle: this.modePassationMarcheForm.value.modePassationMarche,
        type: this.modePassationMarcheForm.value.typeModePassationMarche,
        details: details,
        valeur: this.totalDelais
      }
      //console.log(requestBody)
      //return;
      this.modePassationMarcheService.create(requestBody).subscribe({
        next: () => {
          this.loadModePassationMarche();
          this.isLoading = false;
          this.router.navigate([
            routeAlias.parameters.home,
            routeAlias.parameters.marches.home,
            routeAlias.parameters.marches.mode_passation_marches.home
          ]);
        },
        error: (error) => {
          console.error('Erreur lors de la mise à jour de la ligne budgétaire :', error);
          this.isLoading = false;
        }
      });
    }
  }

  loadModePassationMarche(): void {
    this.modePassationMarcheService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.modePassationMarches = response.data;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }

  loadTypeModePassation(): void {
    this.typeModePassationService.getAllByAppId(this.appService.getAppId()).subscribe({
      next: (response: any) => {
        this.typeModePassations = response.data.map((item: TypeModePassationRes) => ({
          value: item.libelle, // Assurez-vous que c'est bien l'ID (ou le code) qui est la valeur
          label: item?.libelle
        }));;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }

  calculateTotalDelais(): void {
    let sum = 0;
    const formValues = this.modePassationMarcheForm.value;

    // Liste des champs numériques à additionner
    const numericFields = [
      'delaiPublication', 'delaiPublicationSecond', 'montage',
      'lancement', 'ouverture', 'evaluation', 'negociationGreGre',
      'organeControle', 'verificationDisponibiliteCredits', 'notificationResultats',
      'delaiAttenteElaborationContrat', 'examenJuridiqueProjetContratCJC',
      'signatureContratTitulaire', 'visaContratJuriste', 'visaContratDM',
      'visaContratDFC', 'visaContratDCGIS', 'visaContratDGA',
      'signatureContratDG', 'notificationContratTitulaireSC', 'delaiDelivranceOS'
    ];

    numericFields.forEach(field => {
      const value = formValues[field];
      // Convertir en nombre et ajouter si c'est un nombre valide
      const numValue = parseInt(value, 10);
      if (!isNaN(numValue)) {
        sum += numValue;
      }
    });
    this.totalDelais = sum;
  }
}
